module.exports = __webpack_public_path__ + "img/eat_out_23.f522a914.jpg";